/*
 * @Date: 2022-10-17 16:01:30
 * @LastEditTime: 2022-10-18 09:20:35
 * @Description:
 */
const state = {
  errors: [],
};
const getters = {
  getErrorStatus(state) {
    return state.errors?.length > 0;
  },
  getErrors(state) {
    return state.errors;
  },
};
const mutations = {
  updateErrors(state, payload) {
    state.errors = payload;
  },
};

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
